import $ from 'jquery';

/**
 * 
 * Product CAD section realated functions
 * scroll to cad section on navigation hash set
 * 
 */

const ProductCAD = (() => {

    const SELECTOR = ".paragraph-product-cad";
    const OFFSET = 100;

    const initialize = () => {

        const $cadSection = $(SELECTOR);

        if ($cadSection.length) {
            
            // check for hash in url
            var hashVal = window.location.hash;
            if (hashVal) {
                const $anchor = $cadSection.find(`.anchor-id[data-id="${hashVal.replace('#', '')}"]`);
                // check if hash is in cad section
                if ($anchor.length) {
                    // scroll to cad section
                    $('html, body').animate({
                        scrollTop: $anchor.offset().top - OFFSET
                    }, 400);
                }
            }
        }
    }

    return {
        init: initialize
    }

})($);

export default ProductCAD;